import {
  RED_RGB,
  RED_STRONG_RGB,
  BLUE_LIGHT_RGB,
  GREEN_RGB,
  ORANGE_RGB,
} from "../../utils/colorsTheme";

export const configGraphTime = {
  limitsArray: [8, 7, 5, 0],
  colorsArray: [RED_RGB, ORANGE_RGB, GREEN_RGB, BLUE_LIGHT_RGB],
};

export const configGraphTimeDay = {
  limitsArray: [1.5, 1, 0.5, 0],
  colorsArray: [RED_STRONG_RGB, RED_RGB, ORANGE_RGB, GREEN_RGB],
};
